/**
 * championKitBootAdc — Ezreal / Caitlyn dispatchers (SPY-310).
 * Kept out of championKitBoot.js to avoid god-file growth.
 */
import { registerChampionDispatcher } from './abilityDispatcher.js';
import {
  castEzrealQ, castEzrealW, castEzrealE, castEzrealR
} from '../domain/champions/ezreal.js';
import {
  castCaitlynQ, castCaitlynW, castCaitlynE, castCaitlynR
} from '../domain/champions/caitlyn.js';

export const SPY310_ADC_KEYS = ['ezreal', 'caitlyn'];

registerChampionDispatcher('ezreal', {
  Q(player, worldPos, _projectiles, gameTime) {
    const bucket = [];
    if (!castEzrealQ(player, worldPos.x, worldPos.y, bucket, gameTime)) return null;
    return { type: 'ezreal_q', projectiles: bucket, cooldown: 5.5 };
  },
  W(player, worldPos, _projectiles, gameTime) {
    const bucket = [];
    if (!castEzrealW(player, worldPos.x, worldPos.y, bucket, gameTime)) return null;
    return { type: 'ezreal_w', projectiles: bucket, cooldown: 8.0 };
  },
  E(player, worldPos) {
    if (!castEzrealE(player, worldPos.x, worldPos.y)) return null;
    return { type: 'ezreal_e', projectiles: [], cooldown: 26.0 };
  },
  R(player, worldPos, _projectiles, gameTime) {
    const bucket = [];
    if (!castEzrealR(player, worldPos.x, worldPos.y, bucket, gameTime)) return null;
    return { type: 'ezreal_r', projectiles: bucket, cooldown: 120.0 };
  }
});

registerChampionDispatcher('caitlyn', {
  Q(player, worldPos, _projectiles, gameTime) {
    const bucket = [];
    if (!castCaitlynQ(player, worldPos.x, worldPos.y, bucket, gameTime)) return null;
    return { type: 'caitlyn_q', projectiles: bucket, cooldown: 10.0 };
  },
  W(player, worldPos) {
    if (!castCaitlynW(player, worldPos.x, worldPos.y)) return null;
    return { type: 'caitlyn_w', projectiles: [], cooldown: 0.5 };
  },
  E(player, worldPos, _projectiles, gameTime) {
    const bucket = [];
    if (!castCaitlynE(player, worldPos.x, worldPos.y, bucket, gameTime)) return null;
    return { type: 'caitlyn_e', projectiles: bucket, cooldown: 16.0 };
  },
  R(player, _worldPos, _projectiles, _gameTime, _entities, selectedTarget) {
    if (!selectedTarget) return null;
    if (!castCaitlynR(player, selectedTarget)) return null;
    return { type: 'caitlyn_r', projectiles: [], cooldown: 90.0 };
  }
});
